import { StyledSearchPage } from './style';
import DefaultLayout from '../../components/DefaultLayout';
import { useLocation } from 'react-router-dom';
import useQueryApiClient from '../../../utils/useQueryApiClient';
import { useEffect, useState } from 'react';
import { Card } from '../../../ui/Card';
import { FarmCard } from '../../../ui/Card/FarmCard';
import { ProductData } from '../../../types/ProductData';
import { useIntl } from 'react-intl';
import { Pagination } from 'antd';
import { LaravelPaginator } from '../../../types/LaravelPaginator';
import { FarmData } from '../../../types/FarmData';
import { Spinner } from '../../../ui';
import { options } from 'config/config';

const DEFAULT_IMAGE = options.images.defaultProductImage;

export const SearchPage = () => {
  const [farms, setFarms] = useState<LaravelPaginator<FarmData>>();
  const [products, setProducts] = useState<LaravelPaginator<ProductData>>();
  const [productsPage, setProductsPage] = useState(1);
  const [farmsPage, setFarmsPage] = useState(1);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const search = params.get('search');
  const intl = useIntl();

  const hasProducts = products?.data && products?.data.length > 0;
  const hasFarms = farms?.data && farms.data.length > 0;

  const nothingToShow = !hasProducts && !hasFarms;

  useEffect(() => {
    if (!search) return;

    appendData({
      search,
      products_page: productsPage,
      farms_page: farmsPage,
    });
  }, [search, productsPage, farmsPage]);

  useEffect(() => {
    setProductsPage(1);
    setFarmsPage(1);
  }, [search]);

  const { appendData, isLoading } = useQueryApiClient({
    request: {
      url: 'api/v2/search',
      disableOnMount: true,
    },
    enabled: !!search,
    onSuccess: (response) => handleSuccess(response),
  });

  const handleSuccess = (response: any) => {
    setProducts(response.products);
    setFarms(response.farms);
  };

  return (
    <DefaultLayout.PageLayout>
      <DefaultLayout.PageContent className={'no-padding grey-background'}>
        <Spinner spinning={isLoading} dontRender>
          <div className={'container'}>
            <StyledSearchPage>
              {nothingToShow && (
                <div className={'nothing'}>
                  {intl.formatMessage({ id: 'message.nothing_to_show' })}
                </div>
              )}
              {hasProducts && (
                <div className={'section products'}>
                  <div className={'title'}>
                    <h1>{intl.formatMessage({ id: 'general.products' })}</h1>
                  </div>
                  <div className={'grid-view'}>
                    {hasProducts &&
                      products?.data.map((product: ProductData, index) => (
                        <Card
                          product={product}
                          imageUrl={
                            product?.image_small
                              ? product?.image_small
                              : product?.farm?.logo
                                ? product?.farm?.logo
                                : DEFAULT_IMAGE
                          }
                          key={`product-${index}`}
                          hoverable={true}
                        />
                      ))}
                  </div>
                  <div className={'pagination'}>
                    {hasProducts && (
                      <Pagination
                        current={products?.current_page}
                        total={products?.total}
                        pageSize={products?.per_page}
                        onChange={(page) => setProductsPage(page)}
                        showSizeChanger={false}
                      />
                    )}
                  </div>
                </div>
              )}
              {hasFarms && (
                <div className={'section'}>
                  <div className={'title'}>
                    <h1>{intl.formatMessage({ id: 'general.farms' })}</h1>
                  </div>
                  <div className={'grid-view'}>
                    {farms?.data.map((farm: FarmData) => (
                      <FarmCard farm={farm} isFarmList={true} />
                    ))}
                  </div>
                  <div className={'pagination'}>
                    {hasFarms && (
                      <Pagination
                        current={farms?.current_page}
                        total={farms?.total}
                        pageSize={farms?.per_page}
                        onChange={(page) => setFarmsPage(page)}
                        showSizeChanger={false}
                      />
                    )}
                  </div>
                </div>
              )}
            </StyledSearchPage>
          </div>
        </Spinner>
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};
